import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {catchError, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private url = 'https://mailthis.to/NotionHabitHeroes';

  constructor(private http: HttpClient) { }

  SendEmail(input: any) {
    return this.http.post(this.url, input).pipe(
      map((response: any) => {
        if (response) {
          return response;
        }
      }),
      catchError((error) => of(error))
    );
  }

  /**
   * Same target and POST shape as SendEmail (mailthis.to reads arbitrary JSON
   * fields into the email body; _subject and _replyto are the two fields it
   * treats specially). Unlike SendEmail, failures are left to propagate as a
   * normal Observable error instead of being folded into the success channel,
   * so callers that need a real success/error UI state (e.g. a lead form) can
   * rely on subscribe's next/error split.
   */
  sendLeadEmail(input: any) {
    return this.http.post(this.url, input, { observe: 'response', responseType: 'text' });
  }
}
